<div
  [class]="
    'bg-(--stepoverviewcard-background) rounded-(--stepoverviewcard-border-radius) ' +
    (hasBorder()
      ? 'border-(length:--stepoverviewcard-border-width,var(--border-width-xs)) border-(--stepoverviewcard-border-color)'
      : '')
  "
>
  @for (item of stepConfigs(); track item.step.stepLabel; let last = $last) {
    <div
      [class]="
        'flex flex-col items-start gap-(--stepoverviewcard-gap) px-(--stepoverviewcard-padding-x) py-(--stepoverviewcard-padding-y) ' +
        (!last ? 'border-b border-b-(--stepoverviewcard-border-color)' : '')
      "
    >
      <app-dynamic
        componentName="Chip"
        [props]="{ config: item.chipConfig }"
      />
      <app-dynamic
        componentName="DynamicText"
        [props]="{ config: item.textConfig }"
      />
    </div>
  }
</div>
